<template>
  <a-modal
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :title="title"
    :destroyOnClose="destroyOnClose"
    @ok="submitForm"
    @cancel="handleCancel"
  >
    <template>
      <a-form-model :model="sourceData" ref="form" :rules="rules">
        <a-form-model-item label="担保类型" prop="type">
          <a-select
            v-model="sourceData.type"
            placeholder="please select your zone"
          >
            <a-select-option
              :value="item.value"
              v-for="item in typeOptionList"
              :key="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="文件编号">
          <a-input v-model="sourceData.code" />
        </a-form-model-item>
        <a-form-model-item label="文件名称">
          <a-input v-model="sourceData.fileName" />
        </a-form-model-item>
        <a-form-model-item label="担保方名称">
          <a-input v-model="sourceData.assuranceName" />
        </a-form-model-item>
        <a-form-model-item label="上市公司">
          <a-select v-model="sourceData.isListed" placeholder="请选择上市公司">
            <a-select-option :value="1">
              是
            </a-select-option>
            <a-select-option :value="2">
              否
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="生效日期" prop="efficientDate">
          <a-date-picker
            v-model="sourceData.efficientDate"
            format="YYYY-MM-DD"
            placeholder="请选择生效日期"
            style="width: 100%;"
          />
        </a-form-model-item>
        <a-form-model-item label="到期日期" prop="expireDate">
          <a-date-picker
            v-model="sourceData.expireDate"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择到期日期"
            style="width: 100%;"
          />
        </a-form-model-item>
        <a-form-model-item label="货币单位" prop="currencyUnit">
          <a-select
            v-model="sourceData.currencyUnit"
            placeholder="请选择货币单位"
          >
            <a-select-option :value="1">
              RMB
            </a-select-option>
            <a-select-option :value="2">
              USD
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="担保金额" prop="validAmount">
          <a-input v-model="sourceData.validAmount" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input v-model="sourceData.remark" />
        </a-form-model-item>
        <a-form-item label="选择文件">
          <a-upload
            :multiple="true"
            :custom-request="_uploadFile"
            :remove="handleRemove"
            :fileList="fileList"
          >
            <a-button>
              <a-icon type="upload" />
              选取文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form-model>
    </template>
  </a-modal>
</template>
<script>
//
import { addAssurance, uploadAssurance } from '../api'
import mixin from '../mixin'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: {},
  mixins: [mixin],
  data() {
    return {
      attachment: [],
      visible: false,
      confirmLoading: false,
      sourceData: {
        companyId: this.$route.params.id,
        id: '',
        type: '',
        code: '',
        assuranceName: '',
        efficientDate: '',
        expireDate: '',
        attachmentIds: [],
        fileName: '',
        currencyUnit: '',
        validAmount: '',
        isListed: '',
        remark: '',
      },
      rules: {
        type: [
          {
            required: true,
            message: '请选择担保类型',
            trigger: 'blur',
          },
        ],
        efficientDate: [
          {
            required: true,
            message: '请选择生效日期',
            trigger: 'change',
          },
        ],
        expireDate: [
          { required: true, message: '请选择到期日期', trigger: 'change' },
        ],
        currencyUnit: [
          {
            required: true,
            message: '请选择货币单位',
            trigger: 'change',
          },
        ],
        validAmount: [
          {
            required: true,
            message: '请输入担保金额',
            trigger: 'change',
          },
        ],
      },
      checkboxList: [],
      tableRow: {},
      defaultFileList: [],
      fileList: [],
      filters: [],
      typeOptionList: [],
      title: '新增',
      destroyOnClose: true,
    }
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  created() {
    for (var key in this.TYPE_NAME_OBJ) {
      this.typeOptionList.push({
        label: this.TYPE_NAME_OBJ[key],
        value: Number(key),
      })
    }
  },
  methods: {
    async _uploadFile(data) {
      const { file } = data
      const formData = new FormData()
      formData.append('file', file)
      try {
        const { data } = await uploadAssurance(formData)
        this.attachment = [data]
        this.fileList = [
          {
            uid: file.uid,
            name: file.name,
            status: 'done',
          },
        ]
      } catch (error) {
        console.log(error)
      }
    },
    handleRemove() {
      this.fileList.splice(0, Infinity)
    },
    // 新增
    add() {
      this.visible = true
      this.$nextTick(() => {
        // 初始化数据
        this.fileList = []
        for (let key in this.sourceData) {
          if (key !== 'companyId') {
            this.sourceData[key] = ''
          }
        }
      })
      this.title = '新增'
    },
    // 维护
    async edit(tableRow) {
      this.title = '编辑'
      this.visible = true
      this.$nextTick(() => {
        this.tableRow = tableRow
        for (let key in this.sourceData) {
          this.sourceData[key] = tableRow[key]
          if (tableRow['attachments'].length) {
            this.fileList = [
              {
                name: tableRow['attachments'][0].fileName,
                uid: tableRow['attachments'][0].id,
              },
            ]
            this.sourceData['attachmentIds'] = [tableRow['attachments'][0].id]
          }
          this.sourceData['efficientDate'] = moment(
            tableRow['efficientDate'],
          ).format('YYYY-MM-DD')
          this.sourceData['expireDate'] = moment(tableRow['expireDate']).format(
            'YYYY-MM-DD',
          )
        }
      })
    },
    // 取消
    handleCancel() {
      this.visible = false
    },
    // 校验数据
    async validateForm() {
      if (!this.fileList || !this.fileList.length) {
        this.$notification.warn({
          message: '提示',
          description: '请上传文件',
        })
        this.confirmLoading = false
        return
      }
      var values = await this.$refs.form.validate()
      if (values) {
        return this.sourceData
      }
    },
    // 新增｜编辑
    async submitForm() {
      const data = await this.validateForm()
      if (this.attachment.length) {
        data.attachmentIds = this.attachment
      } else {
        data.attachmentIds = []
      }
      if (data) {
        data.companyId = this.$route.params.id
        try {
          this.confirmLoading = true
          await addAssurance(data)
          this.visible = false
          this.confirmLoading = false
          this.$emit('getTableList')
        } catch (err) {
          console.log(err)
          this.confirmLoading = false
        }
      }
    },
  },
}
</script>
